function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import TitleFieldsConfig from "segments/desktop/core-components/title/fields-config";
import { XXS, XS_M, XS, SM, MD, LG, LGR, XL } from "constants/sizes";
import { BACKGROUND_COLOR_OPTIONS } from "segments/segments-service";
export default _object_spread_props(_object_spread({}, TitleFieldsConfig), {
    theme: {
        type: FIELD_TYPES.COLOR_PICKER,
        label: "Theme",
        possibleColors: BACKGROUND_COLOR_OPTIONS
    },
    titleSize: {
        type: FIELD_TYPES.COMBO,
        label: "Title Size",
        options: [
            {
                value: XXS,
                text: "11px (formerly 12px)"
            },
            {
                value: XS_M,
                text: "14px (formerly 16px)"
            },
            {
                value: XS,
                text: "22px (formerly 24px)"
            },
            {
                value: SM,
                text: "28px (formerly 32px)"
            },
            {
                value: MD,
                text: "36px (formerly 40px)"
            },
            {
                value: LG,
                text: "44px (formerly 50px)"
            },
            {
                value: LGR,
                text: "54px (formerly 60px)"
            },
            {
                value: XL,
                text: "64px (formerly 72px)"
            }
        ]
    },
    textAlign: {
        type: FIELD_TYPES.COMBO,
        label: "Text Align",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            },
            {
                value: "right",
                text: "Right"
            }
        ]
    }
});
